import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-box",
  "use": "icon-box-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-box\">\r\n<path d=\"M62.5,14.5l-7.6-11C53.4,1.3,50.9,0,48.2,0H15.8c-2.7,0-5.2,1.3-6.8,3.5l-7.6,11c-0.9,1.4-1.5,3-1.5,4.7v36.6\r\n\tC0,60.3,3.7,64,8.2,64h47.5c4.6,0,8.2-3.7,8.2-8.2l0,0V19.2C64,17.5,63.5,15.9,62.5,14.5z M48.2,6.4c0.6,0,1.2,0.3,1.5,0.8l4.8,6.9\r\n\tH35.2V6.4H48.2z M14.3,7.2c0.3-0.5,0.9-0.8,1.5-0.8h13v7.7H9.6L14.3,7.2z M57.6,55.8c0,1-0.8,1.8-1.8,1.8c0,0,0,0,0,0H8.2\r\n\tc-1,0-1.8-0.8-1.8-1.8c0,0,0,0,0,0V22.1c0-0.9,0.7-1.6,1.6-1.6l0,0h48c0.9,0,1.6,0.7,1.6,1.6V55.8z\" />\r\n<path d=\"M22.4,26.9h19.2c2.1,0,3.2,1.1,3.2,3.2l0,0c0,2.1-1.1,3.2-3.2,3.2H22.4c-2.1,0-3.2-1.1-3.2-3.2l0,0\r\n\tC19.2,27.9,20.3,26.9,22.4,26.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/box.svg
// module id = N5kO
// module chunks = 225